import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "mweb-mega-menu" */ './MegaMenu'));
